// Generated by scripts/generate-app-version.mjs from version.config.json.
// Do not edit manually.
export const APP_VERSION_CONFIG = {
  "major": 0,
  "minor": 1,
  "patch": 4,
  "buildSuffix": 0
}

export function getAppVersion() {
  const buildDate = normalizeBuildDate(getRuntimeValue('CRYSALIA_BUILD_DATE')) || '000000'

  return `V${APP_VERSION_CONFIG.major}.${APP_VERSION_CONFIG.minor}.${APP_VERSION_CONFIG.patch}.${buildDate}${APP_VERSION_CONFIG.buildSuffix}`
}

function getRuntimeValue(key) {
  if (typeof window === 'undefined') return ''
  return window[key]
}

function normalizeBuildDate(value) {
  const raw = String(value || '').trim()
  if (/^\d{6}$/.test(raw)) return raw

  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(raw)
  if (isoMatch) return `${isoMatch[1].slice(-2)}${isoMatch[2]}${isoMatch[3]}`

  return ''
}
